import { useState } from "react";

import {
  AtsIntegration,
  WorkdayIntegrationContext,
  WorkdayConfig,
} from "./WorkdayIntegrationContext";
import { TokensStep } from "./components/steps/TokensStep";
import { EndpointsAndSecretsStep } from "./components/steps/EndpointsAndSecretsStep";
import { PackagesAndSettingsStep } from "./components/steps/PackagesAndSettingsStep";

export function WorkdayIntegrationSetupPage() {
  const [atsIntegrationData, setAtsIntegration] = useState<AtsIntegration>({
    oauth_token_endpoint: "",
    wsdl_endpoint: "",
    oauth_client_id: "",
    oauth_client_secret: "",
    oauth_refresh_token: "",
    oauth_refresh_token_lifetime: 0,
    report_url_type: "DIRECT_PDF_URL",
    should_create_users_just_in_time: false,
    packages: [],
  });
  const [currentStep, setCurrentStep] = useState(0);
  const [workdayConfig, setWorkdayConfig] = useState<WorkdayConfig | null>(
    null
  );

  const steps = [
    <TokensStep key="TokensStep" />,
    <EndpointsAndSecretsStep key="EndpointsAndSecretsStep" />,
    <PackagesAndSettingsStep key="PackagesAndSettingsStep" />,
  ];

  const goToNextStep = () => setCurrentStep((curr) => curr + 1);
  const goToPrevStep = () => setCurrentStep((curr) => curr - 1);

  return (
    <WorkdayIntegrationContext.Provider
      value={{
        atsIntegrationData,
        setAtsIntegration,
        goToNextStep,
        goToPrevStep,
        currentStep,
        workdayConfig,
        setWorkdayConfig,
      }}
    >
      {steps[currentStep]}
    </WorkdayIntegrationContext.Provider>
  );
}
